// Let the document know when the mouse is being used
document.body.addEventListener('mousedown', function () {
  document.body.classList.add('using-mouse');
});
document.body.addEventListener('keydown', function () {
  document.body.classList.remove('using-mouse');
});


$(document).ready(function () {
  var settings = document.querySelectorAll('input[type="checkbox"]');

  for (var i = 0; i < settings.length; i++) {
    var setting = settings[i];

    setting.addEventListener('change', function (e) {
      setTimeout(function () {
        $.fn.matchHeight._update();
      }, 20);

      document.documentElement.classList.toggle(e.target.value)
    });
    setting.addEventListener('keypress', function (e) {
      if (13 == e.keyCode) {

        setTimeout(function () {
          $.fn.matchHeight._update();
        }, 20);

        document.documentElement.classList.toggle(e.target.value)
      }
    });
  }

});



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/Js/components/navi/navi.js
 **/